import { List, OrderedMap } from "immutable";
import { loadingAsyncState } from "widgets-for-react";
import { fixMediaUrl, processRichText } from "../../Shared/api/drupal/drupalApi";
import { DrupalEmbedToVideo, DrupalMediaToVideo } from "../../Shared/api/drupal/nodeConversionHelpers";
import { loadFormstackForm } from "../custom_components/components/formstack/formstack_api";
import { slugify } from "../custom_utils/helpers";
import { getTeasers } from "./api";
export const richTextBlock = (p)=>({
        kind: "richText",
        title: p.field_title,
        html: p.field_rich_text ? processRichText(p.field_rich_text) : "",
        primaryActionTitle: p.field_primary_action ? p.field_primary_action.title : "",
        primaryActionUrl: p.field_primary_action ? p.field_primary_action.url : "",
        secondaryActionTitle: p.field_secondary_action ? p.field_secondary_action.title : "",
        secondaryActionUrl: p.field_secondary_action ? p.field_secondary_action.url : "",
        media: p.field_inline_media ? {
            media: mediaBlock(p.field_inline_media),
            position: p.field_inline_media.field_position == "text_left" ? "text_left" : "text_right"
        } : "none"
    });
export const mediaBlock = (p)=>{
    return p.field_media.bundle == "video" ? {
        kind: "video",
        video: DrupalMediaToVideo(p)
    } : {
        kind: "image",
        imageUrl: fixMediaUrl(p.field_media.field_media_image.image.style_urls["800w"]),
        imageUrlFallback: fixMediaUrl(p.field_media.field_media_image.image.style_urls["800w_fb"]),
        imageAlt: p.field_media.field_media_image.alt
    };
};
export const faqBlock = (p)=>({
        kind: "faq",
        title: p.field_faq_title,
        entries: p.field_faq_item.reduce((a, e)=>a.set(e.label, e.field_answer ? processRichText(e.field_answer) : ""), OrderedMap())
    });
export const highlightBlock = (p)=>({
        kind: "highlight",
        title: p.field_title,
        subtitle: p.field_subtitle,
        content: p.field_rich_text
    });
export const tippedActivitiesBlock = (p)=>({
        kind: "tipped_activities",
        title: p.field_title,
        content: p.field_rich_text,
        linkTitle: p.field_link.title,
        linkUrl: p.field_link.url,
        row_count: p.field_row_count || 3,
        regions: []
    });
export const buttonBlock = (p)=>({
        kind: "knop",
        caption: p.field_link.title,
        href: p.field_link.url
    });
export const imagesBlock = (p)=>({
        kind: "images",
        images: p.field_images.reduce((l, i)=>l.push({
                imageAlt: i.field_media_image.alt,
                imageUrl: fixMediaUrl(i.field_media_image.image.style_urls["790x445"]),
                imageUrlFallback: fixMediaUrl(i.field_media_image.image.style_urls["16x9"])
            }), List())
    });
export const vacancyOverviewBlock = (p)=>{
    var _p_field_category;
    return {
        kind: "vacancy_overview",
        title: p.field_title,
        html: p.field_rich_text,
        placeholder: p.field_placeholder_text,
        category_id: ((_p_field_category = p.field_category) === null || _p_field_category === void 0 ? void 0 : _p_field_category.id) ?? null,
        row_count: p.field_row_count ? p.field_row_count : 3
    };
};
export const booksOverviewBlock = (p)=>({
        kind: "books",
        books: p.field_books.map((b)=>({
                title: b.field_title,
                author: b.field_author,
                imageUrl: fixMediaUrl(b.field_image.field_media_image.image.style_urls["390h"]),
                imageUrlFallback: fixMediaUrl(b.field_image.field_media_image.image.style_urls["400h_fb"]),
                imageAlt: b.field_image.field_media_image.alt,
                url: b.field_link.url
            })).toList(),
        title: p.field_title,
        text: p.field_text
    });
export const themakiezerBlock = (p)=>({
        kind: "themakiezer",
        embedId: p.field_themakiezer_embed_id,
        title: p.field_title,
        text: p.field_text
    });
export const featuredContentBlock = (p)=>({
        kind: "featured_content",
        title: p.field_title,
        html: p.field_rich_text,
        imageUrl: fixMediaUrl(p.field_image.field_media_image.image.style_urls["800w"]),
        imageUrlFallback: fixMediaUrl(p.field_image.field_media_image.image.style_urls["800w_fb"]),
        imageAlt: p.field_image.field_media_image.alt,
        linkTitle: p.field_link.title,
        linkUrl: p.field_link.url
    });
export const activityClusterBlock = (p)=>({
        kind: "activity_cluster",
        title: p.field_title,
        description: p.field_text,
        slug: "",
        activitySummariesIds: p.field_product_db_ids,
        row_count: p.field_row_count ? p.field_row_count : 3
    });
export const subscriptionsBlock = (p)=>({
        kind: "subscription_block"
    });
export const contentGridBlock = (p)=>({
        kind: "content_grid",
        row_count: p.field_row_count ? p.field_row_count : 3,
        items: p.field_content_grid_items.reduce((l, i)=>l.push({
                title: i.field_title,
                subtitle: i.field_subtitle ? i.field_subtitle : "",
                label: i.field_label ? i.field_label : "",
                imageAlt: i.bundle == "content_grid_item" ? i.field_image.field_media_image.alt : "",
                imageUrl: i.bundle == "content_grid_item" ? fixMediaUrl(i.field_image.field_media_image.image.style_urls["790x445"]) : "",
                imageUrlFallback: i.bundle == "content_grid_item" ? fixMediaUrl(i.field_image.field_media_image.image.style_urls["16x9"]) : "",
                video: i.bundle == "content_grid_video" ? DrupalEmbedToVideo(i.field_video, i.field_title) : undefined,
                linkUrl: i.field_link ? i.field_link.url : ""
            }), List())
    });
export const carouselContentGridBlock = (p)=>({
        kind: "carousel_content_grid",
        title: p.field_title,
        row_count: p.field_row_count ? p.field_row_count : 3,
        items: p.field_content_grid_items.reduce((l, i)=>l.push({
                title: i.field_title,
                subtitle: i.field_subtitle ? i.field_subtitle : "",
                label: i.field_label ? i.field_label : "",
                imageAlt: i.bundle == "content_grid_item" ? i.field_image.field_media_image.alt : "",
                imageUrl: i.bundle == "content_grid_item" ? fixMediaUrl(i.field_image.field_media_image.image.style_urls["790x445"]) : "",
                imageUrlFallback: i.bundle == "content_grid_item" ? fixMediaUrl(i.field_image.field_media_image.image.style_urls["16x9"]) : "",
                video: i.bundle == "content_grid_video" ? DrupalEmbedToVideo(i.field_video, i.field_title) : undefined,
                linkUrl: i.field_link.url
            }), List()),
        primaryActionTitle: p.field_primary_action ? p.field_primary_action.title : "",
        primaryActionUrl: p.field_primary_action ? p.field_primary_action.url : ""
    });
export const pageGridBlock = (p)=>({
        kind: "async_block",
        promise: ()=>getTeasers(p.field_page_grid_items.map((i)=>i.id.toString()).toArray()),
        block: (teasers)=>({
                kind: "content_grid",
                title: p.field_title,
                row_count: p.field_row_count ? p.field_row_count : 3,
                items: teasers.map((t)=>({
                        title: t.title,
                        linkUrl: t.url,
                        imageAlt: t.imageAlt,
                        imageUrl: t.imageUrl,
                        imageUrlFallback: t.imageUrlFallback,
                        subtitle: t.description
                    })).toList(),
                primaryActionTitle: p.field_primary_action ? p.field_primary_action.title : undefined,
                primaryActionUrl: p.field_primary_action ? p.field_primary_action.url : undefined
            })
    });
export const quoteBlock = (p)=>{
    return {
        kind: "quote",
        quote: p.field_quote_text,
        source: p.field_quote_source && p.field_quote_source != "" ? p.field_quote_source : undefined
    };
};
export const collectionSearchBarBlock = (p)=>{
    return {
        kind: "collection_search_bar"
    };
};
export const gridBlock = (p)=>{
    return {
        kind: "grid_block",
        title: p.field_title,
        row_count: p.field_row_count ? p.field_row_count : 3,
        items: p.field_grid_items.reduce((l, i)=>l.push({
                title: i.field_title,
                imageAlt: i.field_media.field_media_image.alt,
                imageUrl: i.field_media.field_media_image.image.style_urls["800w"],
                imageUrlFallback: i.field_media.field_media_image.image.style_urls["800w_fb"],
                intro: i.field_text,
                linkUrl: i.field_link.url
            }), List())
    };
};
export const formstackBlock = (p)=>{
    return {
        kind: p.bundle,
        formId: p.field_formstack_form_id,
        state: loadingAsyncState(()=>loadFormstackForm(p.field_formstack_form_id))
    };
};
export const wordCloudBlock = (p)=>{
    var _p_field_primary_action, _p_field_primary_action1;
    return {
        kind: "word_cloud_block",
        title: p.field_title,
        description: p.field_description,
        label: p.field_label,
        form_id: p.field_formstack_form_id,
        field_id: p.field_formstack_field_id,
        number_of_options: p.field_number_of_options,
        primaryActionTitle: (_p_field_primary_action = p.field_primary_action) === null || _p_field_primary_action === void 0 ? void 0 : _p_field_primary_action.title,
        primaryActionUrl: (_p_field_primary_action1 = p.field_primary_action) === null || _p_field_primary_action1 === void 0 ? void 0 : _p_field_primary_action1.url
    };
};
export const ctaBlock = (p)=>{
    return {
        kind: "cta_block",
        title: p.field_title,
        description: p.field_description,
        primaryActionTitle: p.field_primary_action ? p.field_primary_action.title : "",
        primaryActionUrl: p.field_primary_action ? p.field_primary_action.url : "",
        secondaryActionTitle: p.field_secondary_action ? p.field_secondary_action.title : "",
        secondaryActionUrl: p.field_secondary_action ? p.field_secondary_action.url : ""
    };
};
export const subMenuBlock = (p)=>{
    return {
        kind: "submenu",
        title: p.field_title,
        text: p.field_text,
        links: p.field_items.reduce((l, i)=>l.push({
                title: i.field_link.title,
                url: i.field_link.url.startsWith('#') ? '#' + slugify(i.field_link.url) : i.field_link.url // Leave the URL intact (query params are already decoded from JSON)
            }), List())
    };
};
export const newsletterSignupBlock = (_)=>({
        kind: 'newsletterForm'
    });
export const emptyBlock = ()=>({
        kind: "empty"
    });
